module.exports = __webpack_public_path__ + "images/banner_04.jpg?409d664670a38ccd92f52e0028a380c9";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_04.jpg
// module id = 218
// module chunks = 1